import React, { memo } from "react";
import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";

interface RecommendationBadgeProps {
  recommendation: 'Buy' | 'Hold' | 'Sell';
}

export const RecommendationBadge = memo(({ recommendation }: RecommendationBadgeProps) => {
  const badgeStyles: { [key in 'Buy' | 'Hold' | 'Sell']: string } = {
    Buy: "bg-green-500/20 text-green-400 border-green-500/30",
    Sell: "bg-red-500/20 text-red-400 border-red-500/30",
    Hold: "bg-amber-500/20 text-amber-300 border-amber-500/30",
  };

  const style = badgeStyles[recommendation] || badgeStyles.Hold; // Default to Hold style if needed

  return (
    <Badge variant="outline" className={cn("text-xs py-0 px-1.5 h-5 rounded-sm", style)}>
      {recommendation.toUpperCase()}
    </Badge>
  );
});

RecommendationBadge.displayName = 'RecommendationBadge';

export default RecommendationBadge;
